export type EmailIconProps = {
  width: string | number;
  height: string | number;
};

const EmailIcon = ({ width, height }: EmailIconProps) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="mail filled">
          <path
            id="Subtract"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.00048 6.96878C2.00016 6.97915 2 6.98956 2 7V25C2 25.5523 2.44771 26 3 26H29C29.5523 26 30 25.5523 30 25V7C30 6.98957 29.9998 6.97917 29.9995 6.96882L16.6402 18.1016C16.2693 18.4106 15.7307 18.4106 15.3598 18.1016L2.00048 6.96878ZM28.038 6H3.96204L16 16.0317L28.038 6Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </>
  );
};

export default EmailIcon;
